module.exports = __webpack_public_path__ + "static/media/logo_white.29e5e4e6.svg";